import Snap from 'snapsvg-cjs';
import createDots from './create-dots';
import createTriangle from './create-triangle';

const sectionPageHeader = () => {
  const bg = Snap('.js-page-header-anim');
  if (bg) {
    createDots(bg, 11, 16, 830, 15);
    if (
      document
        .querySelector('body')
        .classList.contains('post-type-archive-case-study')
    ) {
      const circle = bg.circle(1245, -50, 320);
      circle.attr({
        fill: 'transparent',
        stroke: '#ff0050',
        strokeWidth: '2px',
      });
      createTriangle(bg, 80, 30, 932, 100, 40);
      createTriangle(bg, 80, 215, 1232, 200, 50);
      createTriangle(bg, 70, 235, 1482, 70, 20);
    } else if (
      document.querySelector('body').classList.contains('single-offer')
    ) {
      createTriangle(bg, 200, 50, 1250, 150, 50);
    } else {
      createTriangle(bg, 90, 45, 1032, 40, 40);
      createTriangle(bg, 200, 130, 1382, -40, 80);
      createTriangle(bg, 80, 320, 982, 450, 40);
      createTriangle(bg, 60, 240, 1410, 470, 15);
    }
  }
  if (document.querySelector('.editor-post-featured-image')) {
    document.querySelector(
      '.c-page-header__image',
    ).src = document.querySelector('.editor-post-featured-image img').src;
  }
};

export default sectionPageHeader;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-page-header.js